import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiPromptBlocks,
  BackendMutationCreateCsvMultiPromptBlocksArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_BLOCKS } from './schema';

const MUTATION = gql`
  mutation CreateCsvMultiPromptBlocks(
    $csvId: ID!
    $description: String!
    $selectedHeaders: [String!]!
    $toolList: JSON!
  ) {
    createCsvMultiPromptBlocks(
      csvId: $csvId
      description: $description
      selectedHeaders: $selectedHeaders
      toolList: $toolList
    ) {
      ...MultiPromptBlocks
    }
  }
  ${FRAGMENT_MULTI_PROMPT_BLOCKS}
`;

type Variables = BackendMutationCreateCsvMultiPromptBlocksArgs;
type Result = BackendMultiPromptBlocks;

export const createCsvMultiPromptBlocks = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
